<template>
  <div>
    <div class="alert alert-danger" v-if="form.errors.any() || this.errorGeoCode === true">
      {{ 'revisions.error_please_verify_all_fields' | trans }}
    </div>
    <div class="mb-2" v-if="form.username">{{ 'revisions.created_by_x_at_x' | trans({user: form.username}) }}
      {{ formatDate(form.created_at) }}<br/>
      <div class="d-flex align-items-center">
        Quelle: 
        <a :href="form.source" class="d-inline-block text-truncate ml-2" style="max-width: 400px;" target="_blank">{{ form.source }}</a>
      </div>
    </div>
    <b-form-group
        class="required"
        :label="'revisions.entry_type' | trans"
        label-for="entry_type"
        :invalid-feedback="form.errors.gets('entry_type')"
        :state="form.errors.getState('entry_type')">
      <b-form-select
          id="entry_type"
          v-model="form.entry_type"
          :options="[
              {text: trans('revisions.new_opening'), value: 'new_opening'},
              {text: trans('revisions.reopening'), value: 'reopening'}
            ]"
          :state="form.errors.getState('entry_type')">
      </b-form-select>
      <old-value :value="form.entry_type" :oldValue="previousRevision.entry_type"
                 :oldValuePretty="previousRevision.entry_type"></old-value>
    </b-form-group>
    <b-form-group
        class="required"
        :description="'revisions.title_description' | trans"
        :label="'revisions.title' | trans"
        label-for="title"
        :invalid-feedback="form.errors.gets('title')"
        :state="form.errors.getState('title')">
      <b-input
          id="title"
          v-model="form.title"
          :state="form.errors.getState('title')"
      ></b-input>
      <old-value :value="form.title" :oldValue="previousRevision.title"></old-value>
    </b-form-group>
    <b-form-group
        class="required"
        :label="'revisions.category' | trans"
        label-for="category_id"
        :invalid-feedback="form.errors.gets('category_id')"
        :state="form.errors.getState('category_id')">
      <b-form-select
          id="category_id"
          v-model="form.category_id"
          :options="categories.filter(function(val) {
                    if(val.name === 'Einzelhandel' && newForm === 'yes') {
                      return false; // skip
                    }
                      return true;
                    }).map(function(val){
                         return {value: val.id, text: val.name}
                    })"
          :state="form.errors.getState('category_id')">
        <template slot="first">
          <option :value="''">{{ 'revisions.category_default' | trans }}</option>
        </template>
      </b-form-select>
      <old-value :value="form.category_id" :oldValue="previousRevision.category_id"
                 :oldValuePretty="previousRevision.category_id ? categories.find(function(c){ return c.id === previousRevision.category_id; }).name : ''"></old-value>
    </b-form-group>

    <label class="required">{{ 'revisions.timespan' | trans }}</label>
    <b-card no-body>
      <b-tabs card @input="onTabSelected">
        <b-tab :title="'revisions.day' | trans" :active="dayTabSelected">
          <date-picker
              v-model="form.event_date"
              :invalid-feedback="form.errors.gets('event_date')"
              :state="form.errors.getState('event_date')"
          ></date-picker>
        </b-tab>
        <b-tab :title="'revisions.month' | trans" :active="monthTabSelected">
          <b-form-group
              :invalid-feedback="form.errors.gets('select_month')"
              :state="form.errors.getState('select_month')">
            <b-form-select
                id="select_month"
                v-model="form.select_month"
                :options="months"
                :state="form.errors.getState('select_month')">
              <template slot="first">
                <option value="">{{ 'revisions.month_default' | trans }}</option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group
              :invalid-feedback="form.errors.gets('select_year_for_month')"
              :state="form.errors.getState('select_year_for_month')">
            <b-form-select
                id="select_year_for_month"
                v-model="form.select_year_for_month"
                :options="yearsWithRevisionYear"
                :state="form.errors.getState('select_year_for_month')">
              <template slot="first">
                <option value="">{{ 'revisions.year_default' | trans }}</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-tab>
        <b-tab :title="'revisions.quarter' | trans" :active="quarterTabSelected">
          <b-form-group
              :invalid-feedback="form.errors.gets('select_quarter')"
              :state="form.errors.getState('select_quarter')">
            <b-form-select
                id="select_quarter"
                v-model="form.select_quarter"
                :options="quarters"
                :state="form.errors.getState('select_quarter')">
              <template slot="first">
                <option value="">{{ 'revisions.quarter_default' | trans }}</option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group
              :invalid-feedback="form.errors.gets('select_year_for_quarter')"
              :state="form.errors.getState('select_year_for_quarter')">
            <b-form-select
                id="select_year_for_quarter"
                v-model="form.select_year_for_quarter"
                :options="yearsWithRevisionYear"
                :state="form.errors.getState('select_year_for_quarter')">
              <template slot="first">
                <option value="">{{ 'revisions.year_default' | trans }}</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-tab>
        <b-tab :title="'revisions.half_year' | trans" :active="halfYearTabSelected">
          <b-form-group
              :invalid-feedback="form.errors.gets('select_half_year')"
              :state="form.errors.getState('select_half_year')">
            <b-form-select
                id="select_half_year"
                v-model="form.select_half_year"
                :options="halfYears"
                :state="form.errors.getState('select_half_year')">
              <template slot="first">
                <option value="">{{ 'revisions.half_year_default' | trans }}</option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group
              :invalid-feedback="form.errors.gets('select_year_for_half_year')"
              :state="form.errors.getState('select_year_for_half_year')">
            <b-form-select
                id="select_year_for_half_year"
                v-model="form.select_year_for_half_year"
                :options="yearsWithRevisionYear"
                :state="form.errors.getState('select_year_for_half_year')">
              <template slot="first">
                <option value="">{{ 'revisions.year_default' | trans }}</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-tab>
        <b-tab :title="'revisions.year' | trans" :active="yearTabSelected">
          <b-form-group
              :invalid-feedback="form.errors.gets('select_year')"
              :state="form.errors.getState('select_year')">
            <b-form-select
                id="select_year"
                v-model="form.select_year"
                :options="yearsWithRevisionYear"
                :state="form.errors.getState('select_year')">
              <template slot="first">
                <option value="">{{ 'revisions.year_default' | trans }}</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-tab>
      </b-tabs>
    </b-card>
    <div class="alert alert-warning p-1 mt-2 mb-1" v-if="isDifferentDate">
      {{ 'revisions.old_value' | trans }} {{ previousRevision.date_as_time_perdiod }}
    </div>

    <div class="form-row">
      <div class="col-md-6">
        <b-form-group
            class="required"
            :label="'revisions.description' | trans"
            label-for="description"
            :invalid-feedback="form.errors.gets('description')"
            :state="form.errors.getState('description')">
          <a href="#format-help">{{ 'revisions.format_help' | trans }}</a>
          <b-textarea
              id="description"
              v-model="form.description"
              :state="form.errors.getState('description')"
              :rows="10"
              @input="descriptionUpdate"
          ></b-textarea>
          <div>{{
              form.description !== null ? form.description.replace(/ +/g, " ").replace(/[\n\r]/g,
                  "").length : 0
            }} {{ 'revisions.characters' | trans }}
          </div>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <label for="html-output-description" class="col-form-label pt-0">{{ 'revisions.html' | trans }}</label>
        <div id="html-output-description" v-html="compiledMarkdownDescription"></div>
      </div>

      <div class="col-12">
        <old-value :value="form.description" :oldValue="previousRevision.description"></old-value>
      </div>
    </div>

    <div v-if="platform === 'neueroeffnung'" class="form-row">
      <div class="col-md-12">
        <button type="button" @click="newOpening()" class="btn btn-primary col">Updateinformation (Eröffnung verschiebt
          sich) hinzufügen
        </button>
      </div>
    </div>

    <div v-if="platform === 'openings24'" class="form-row">
      <div class="col-md-12">
        <button type="button" @click="newOpening()" class="btn btn-primary col">Add update information (opening
          postpones)
        </button>
      </div>
    </div>

    <div v-if="platform === 'openings24'">


      <div class="form-row">
        <div class="col-md-12">
          <b-form-group
              :label="'revisions.street' | trans"
              label-for="street"
              :invalid-feedback="form.errors.gets('street')"
              :state="form.errors.getState('street')">
            <b-input
                id="street"
                v-model="form.street"
                :state="form.errors.getState('street')"
            ></b-input>
          </b-form-group>
          <old-value :value="form.street" :oldValue="previousRevision.street"></old-value>
        </div>
      </div>

      <div class="form-row">
        <div class="col-md-6">
          <b-form-group
              class="required"
              :label="'revisions.city' | trans"
              label-for="city"
              :invalid-feedback="form.errors.gets('city')"
              :state="form.errors.getState('city')">
            <b-input
                id="city"
                v-model="form.city"
                :state="form.errors.getState('city')"
            ></b-input>
          </b-form-group>
          <old-value :value="form.city" :oldValue="previousRevision.city"></old-value>
        </div>
        <div class="col-md-4">
          <b-form-group v-if="showStateList"
                        class="required"
                        :label="'revisions.state' | trans"
                        :invalid-feedback="form.errors.gets('state')"
                        :state="form.errors.getState('state')"
                        label-for="state">
            <b-form-select
                id="state"
                :options="stateList"
                v-model="form.state"
                :state="form.errors.getState('state')"
            ></b-form-select>
          </b-form-group>
          <old-value :value="form.state" :oldValue="previousRevision.state"></old-value>
        </div>
        <div class="col-md-2">
          <b-form-group
              :label="'revisions.postal_code' | trans"
              label-for="postal_code"
              :invalid-feedback="form.errors.gets('postal_code')"
              :state="form.errors.getState('postal_code')">
            <b-input
                id="postal_code"
                v-model="form.postal_code"
                :state="form.errors.getState('postal_code')"
            ></b-input>
          </b-form-group>
        </div>
      </div>

    </div>
    <div v-if="platform === 'neueroeffnung'">
      <div class="form-row">
        <div class="col-md-6">
          <b-form-group
              :label="'revisions.street' | trans"
              label-for="street"
              :invalid-feedback="form.errors.gets('street')"
              :state="form.errors.getState('street')">
            <b-input
                id="street"
                v-model="form.street"
                :state="form.errors.getState('street')"
            ></b-input>
          </b-form-group>
          <old-value :value="form.street" :oldValue="previousRevision.street"></old-value>
        </div>
        <div class="col-md-6">
          <b-form-group
              :label="'revisions.street_number' | trans"
              label-for="street_number"
              :invalid-feedback="form.errors.gets('street_number')"
              :state="form.errors.getState('street_number')">
            <b-input
                id="street_number"
                v-model="form.street_number"
                :state="form.errors.getState('street_number')"
            ></b-input>
          </b-form-group>
          <old-value :value="form.street_number" :oldValue="previousRevision.street_number"></old-value>
        </div>
      </div>

      <div class="form-row">
        <div class="col-md-6">
          <b-form-group
              :label="'revisions.postal_code' | trans"
              label-for="postal_code"
              :invalid-feedback="form.errors.gets('postal_code')"
              :state="form.errors.getState('postal_code')">
            <b-input
                id="postal_code"
                v-model="form.postal_code"
                :state="form.errors.getState('postal_code')"
            ></b-input>
          </b-form-group>
          <old-value :value="form.postal_code" :oldValue="previousRevision.postal_code"></old-value>
        </div>
        <div class="col-md-6">
          <b-form-group
              class="required"
              :label="'revisions.city' | trans"
              label-for="city"
              :invalid-feedback="form.errors.gets('city')"
              :state="form.errors.getState('city')">
            <b-input
                id="city"
                v-model="form.city"
                :state="form.errors.getState('city')"
            ></b-input>
          </b-form-group>
          <old-value :value="form.city" :oldValue="previousRevision.city"></old-value>
        </div>
      </div>
    </div>
    <entry-map :lat="form.lat" :lng="form.lng" :zoom="18"></entry-map>
    <div class="alert alert-danger mt-4" v-if="errorGeoCode">
      {{ 'revisions.could_not_resolve_address' | trans }}
    </div>

    <b-form-group
        class="required"
        :label="'revisions.source' | trans"
        :description="'revisions.source_description' | trans"
        label-for="source"
        :invalid-feedback="form.errors.gets('source')"
        :state="form.errors.getState('source')">
      <b-textarea
          id="source"
          :rows="5"
          v-model="form.source"
          :state="form.errors.getState('source')"
      ></b-textarea>
      <b-textarea v-if="form.status_id === 3"
                  id="infosource"
                  v-model="form.infosource"
                  readonly
      ></b-textarea>
    </b-form-group>
    <old-value :value="form.source" :oldValue="previousRevision.source"></old-value>

    <b-form-group
        label="Verkaufsfläche (in m²)"
        label-for="sales_area"
        :invalid-feedback="form.errors.gets('sales_area')"
        :state="form.errors.getState('sales_area')">
      <b-input
          id="sales_area"
          type="number"
          v-model="form.sales_area"
          :state="form.errors.getState('sales_area')"
      ></b-input>
    </b-form-group>
    <old-value :value="form.sales_area" :oldValue="previousRevision.sales_area"></old-value>


    <div class="form-row">
      <div class="col-md-6">
        <b-form-group
            :label="'revisions.offer' | trans"
            label-for="offer"
            :invalid-feedback="form.errors.gets('offer')"
            :state="form.errors.getState('offer')">
          <a href="#format-help">{{ 'revisions.format_help' | trans }}</a>
          <b-textarea
              id="offer"
              v-model="form.offer"
              :state="form.errors.getState('offer')"
              :rows="10"
              @input="offerUpdate"
          ></b-textarea>
          <div>{{
              form.offer !== null ? form.offer.replace(/ +/g, " ").replace(/[\n\r]/g,
                  "").length : 0
            }} {{ 'revisions.characters' | trans }}
          </div>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <label for="html-output-offer" class="col-form-label pt-0">{{ 'revisions.html' | trans }}</label>
        <div id="html-output-offer" v-html="compiledMarkdownOffer"></div>
      </div>
      <div class="col-12">
        <old-value :value="form.offer" :oldValue="previousRevision.offer"></old-value>
      </div>
    </div>
    <b-form-group
        :label="'revisions.phone' | trans"
        label-for="phone"
        :invalid-feedback="form.errors.gets('phone')"
        :state="form.errors.getState('phone')">
      <b-input
          id="phone"
          v-model="form.phone"
          :state="form.errors.getState('phone')"
      ></b-input>
    </b-form-group>
    <old-value :value="form.phone" :oldValue="previousRevision.phone"></old-value>

    <b-form-group
        :label="'revisions.website_title' | trans"
        label-for="website"
        :invalid-feedback="form.errors.gets('website')"
        :state="form.errors.getState('website')">
      <b-input
          id="website"
          v-model="form.website"
          :state="form.errors.getState('website')"
      ></b-input>
    </b-form-group>
    <old-value :value="form.website" :oldValue="previousRevision.website"></old-value>

    <b-form-group
        :label="'revisions.email' | trans"
        label-for="email"
        :invalid-feedback="form.errors.gets('email')"
        :state="form.errors.getState('email')">
      <b-input
          id="email"
          v-model="form.email"
          :state="form.errors.getState('email')"
      ></b-input>
    </b-form-group>
    <old-value :value="form.email" :oldValue="previousRevision.email"></old-value>

    <b-card class="mb-3">
      <h5 class="mb-3">Kontaktinformationen</h5>
      <div class="form-row">
        <div class="col-12 col-md-3">
          <b-form-group
              :label="'revisions.salutation' | trans"
              label-for="salutation"
              :invalid-feedback="form.errors.gets('salutation')"
              :state="form.errors.getState('salutation')">
            <b-form-select
                id="salutation"
                v-model="form.salutation"
                :options="[
                    { text: '-- Auswählen --', value: '' },
                    { text: 'Herr', value: 'Herr' },
                    { text: 'Frau', value: 'Frau' }
                ]"
                :state="form.errors.getState('salutation')"
                :disabled="form.unknown_contact_person">
            </b-form-select>
          </b-form-group>
        </div>
        <div class="col-12 col-md-9">
          <b-form-group
              label="Ansprechpartner"
              label-for="contact_person"
              :invalid-feedback="form.errors.gets('contact_person')"
              :state="form.errors.getState('contact_person')">
            <b-input
                id="contact_person"
                v-model="form.contact_person"
                :state="form.errors.getState('contact_person')"
                :disabled="form.unknown_contact_person"
                required
            ></b-input>
          </b-form-group>
          <old-value :value="form.contact_person" :oldValue="previousRevision.contact_person"></old-value>
        </div>
      </div>
      <div class="form-row">
        <div class="col-12 col-md-6">
          <b-form-group
              :label="'revisions.contact_position' | trans"
              label-for="contact_position"
              :invalid-feedback="form.errors.gets('contact_position')"
              :state="form.errors.getState('contact_position')">
            <b-form-select
                id="contact_position"
                v-model="form.contact_position"
                :options="[
                    { text: '-- Auswählen --', value: '' },
                    { text: 'Geschäftsführer/in', value: 'Geschäftsführer/in' },
                    { text: 'Inhaber/in', value: 'Inhaber/in' },
                    { text: 'Marktleiter/in', value: 'Marktleiter/in' },
                    { text: 'Sonstiges', value: 'custom' }
                ]"
                :state="form.errors.getState('contact_position')"
                :disabled="form.unknown_contact_person"
                required
                @change="handleContactPositionChange"
            ></b-form-select>
          </b-form-group>
        </div>
        <div class="col-12 col-md-6" v-if="form.contact_position === 'custom'">
          <b-form-group
              :label="'revisions.contact_position_custom' | trans"
              label-for="contact_position_custom"
              :invalid-feedback="form.errors.gets('contact_position_custom')"
              :state="form.errors.getState('contact_position_custom')">
            <b-input
                id="contact_position_custom"
                v-model="form.contact_position_custom"
                :state="form.errors.getState('contact_position_custom')"
                :disabled="form.unknown_contact_person"
                required
            ></b-input>
          </b-form-group>
        </div>
      </div>
      <div class="form-row">
        <div class="col-12">
          <b-form-group>
            <b-form-checkbox
                id="unknown_contact_person"
                v-model="form.unknown_contact_person"
                @change="handleUnknownContactPersonChange"
            >
              Ansprechpartner unbekannt
            </b-form-checkbox>
          </b-form-group>
        </div>
      </div>
    </b-card>

    <div class="form-row">
      <div class="col-md-6">
        <b-form-group
            :label="'revisions.opening_times' | trans"
            label-for="opening_times"
            :invalid-feedback="form.errors.gets('opening_times')"
            :state="form.errors.getState('opening_times')">
          <a href="#format-help">{{ 'revisions.format_help' | trans }}</a>
          <b-textarea
              id="opening_times"
              v-model="form.opening_times"
              :state="form.errors.getState('opening_times')"
              :rows="10"
              @input="openingTimesUpdate"
          ></b-textarea>
          <div>{{
              form.opening_times !== null ? form.opening_times.replace(/ +/g, " ").replace(/[\n\r]/g,
                  "").length : 0
            }} {{ 'revisions.characters' | trans }}
          </div>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <label for="html-output-opening-times" class="col-form-label pt-0">{{ 'revisions.html' | trans }}</label>
        <div id="html-output-opening-times" v-html="compiledMarkdownOpeningTimes"></div>
      </div>
      <div class="col-12">
        <old-value :value="form.opening_times" :oldValue="previousRevision.opening_times"></old-value>
      </div>
    </div>

    <div class="form-row mb-4 text-small">
      <div class="col-md-12">
        {{ 'revisions.required_field' | trans }}
      </div>
    </div>
  </div>
</template>

<script>
import * as marked from 'marked';


let moment = require("moment");

export default {
  props: {
    categories: {
      type: Array,
      default: function () {
        return [];
      }
    },
    months: {
      type: Array,
      default: function () {
        return [];
      }
    },
    quarters: {
      type: Object,
      default: function () {
        return {};
      }
    },
    halfYears: {
      type: Object,
      default: function () {
        return {};
      }
    },
    years: {
      type: Array,
      default: function () {
        return [];
      }
    },
    form: {
      type: Object,
      default: function () {
        return {};
      }
    },
    previousRevision: {
      type: Object,
      default: function () {
        return {};
      }
    },
    errorGeoCode: {
      type: Boolean,
      default: function () {
        return false;
      }
    },
    showStateList:
        {
          type: Boolean,
          default: function () {
            return (process.env.MIX_VUE_FORM_SHOW_STATES === '1');
          }
        },

    platform:
        {
          type: String,
          default: function () {
            return (process.env.MIX_PLATFORM);
          }
        },

    newForm: {
      type: String,
      required: false
    }

  },
  data: function () {
    // add year of current revision to years array
    let yearsWithRevisionYear = this.years.slice();
    if (this.form.time_period !== "undefined") {
      switch (this.form.time_period) {
        case 2:
          if (yearsWithRevisionYear.indexOf(String(this.form.select_year_for_month)) < 0) {
            yearsWithRevisionYear.push(this.form.select_year_for_month);
          }
          break;
        case 3:
          if (yearsWithRevisionYear.indexOf(String(this.form.select_year_for_quarter)) < 0) {
            yearsWithRevisionYear.push(this.form.select_year_for_quarter);
          }
          break;
        case 4:
          if (yearsWithRevisionYear.indexOf(String(this.form.select_year)) < 0) {
            yearsWithRevisionYear.push(this.form.select_year);
          }
          break;
        case 5:
          if (yearsWithRevisionYear.indexOf(String(this.form.select_year_for_half_year)) < 0) {
            yearsWithRevisionYear.push(this.form.select_year_for_half_year);
          }
          break;
        default:
      }

    }
    return {
      description: this.form.description,
      openingTimes: this.form.opening_times,
      offer: this.form.offer,
      yearsWithRevisionYear: yearsWithRevisionYear.sort(),

      state: "",
      stateList: [
        {value: '', text: ''},
        {value: 'AL', text: 'Alabama (AL)'},
        {value: 'AK', text: 'Alaska (AK)'},
        {value: 'AZ', text: 'Arizona (AZ)'},
        {value: 'AR', text: 'Arkansas (AR)'},
        {value: 'CA', text: 'California (CA)'},
        {value: 'CO', text: 'Colorado (CO)'},
        {value: 'CT', text: 'Connecticut (CT)'},
        {value: 'DE', text: 'Delaware (DE)'},
        {value: 'DC', text: 'District of Columbia (DC)'},
        {value: 'FL', text: 'Florida (FL)'},
        {value: 'GA', text: 'Georgia (GA)'},
        {value: 'HI', text: 'Hawaii (HI)'},
        {value: 'ID', text: 'Idaho (ID)'},
        {value: 'IL', text: 'Illinois (IL)'},
        {value: 'IN', text: 'Indiana (IN)'},
        {value: 'IA', text: 'Iowa (IA)'},
        {value: 'KS', text: 'Kansas (KS)'},
        {value: 'KY', text: 'Kentucky (KY)'},
        {value: 'LA', text: 'Louisiana (LA)'},
        {value: 'ME', text: 'Maine (ME)'},
        {value: 'MD', text: 'Maryland (MD)'},
        {value: 'MA', text: 'Massachusetts (MA)'},
        {value: 'MI', text: 'Michigan (MI)'},
        {value: 'MN', text: 'Minnesota (MN)'},
        {value: 'MS', text: 'Mississippi (MS)'},
        {value: 'MO', text: 'Missouri (MO)'},
        {value: 'MT', text: 'Montana (MT)'},
        {value: 'NE', text: 'Nebraska (NE)'},
        {value: 'NV', text: 'Nevada (NV)'},
        {value: 'NH', text: 'New Hampshire (NH)'},
        {value: 'NJ', text: 'New Jersey (NJ)'},
        {value: 'NM', text: 'New Mexico (NM)'},
        {value: 'NY', text: 'New York (NY)'},
        {value: 'NC', text: 'North Carolina (NC)'},
        {value: 'ND', text: 'North Dakota (ND)'},
        {value: 'OH', text: 'Ohio (OH)'},
        {value: 'OK', text: 'Oklahoma (OK)'},
        {value: 'OR', text: 'Oregon (OR)'},
        {value: 'PA', text: 'Pennsylvania (PA)'},
        {value: 'RI', text: 'Rhode Island (RI)'},
        {value: 'SC', text: 'South Carolina (SC)'},
        {value: 'SD', text: 'South Dakota (SD)'},
        {value: 'TN', text: 'Tennessee (TN)'},
        {value: 'TX', text: 'Texas (TX)'},
        {value: 'UT', text: 'Utah (UT)'},
        {value: 'VT', text: 'Vermont (VT)'},
        {value: 'VA', text: 'Virginia (VA)'},
        {value: 'WA', text: 'Washington (WA)'},
        {value: 'WV', text: 'West Virginia (WV)'},
        {value: 'WI', text: 'Wisconsin (WI)'},
        {value: 'WY', text: 'Wyoming (WY)'}
      ]
    };
  },
  computed: {
    dayTabSelected: function () {
      return this.form.time_period === 1;
    },
    monthTabSelected: function () {
      return this.form.time_period === 2;
    },
    quarterTabSelected: function () {
      return this.form.time_period === 3;
    },
    yearTabSelected: function () {
      return this.form.time_period === 4;
    },
    halfYearTabSelected: function () {
      return this.form.time_period === 5;
    },
    compiledMarkdownDescription: function () {
      if (this.description !== null) {

        if (this.description.length > 0) {
          if (this.newForm === 'yes') {
            this.$cookies.set("description", this.description, "1d");
          }
        }

        return this.description !== "" ? marked(this.description, {sanitize: true}) : "";
      }
      return "";
    },
    compiledMarkdownOpeningTimes: function () {
      if (this.openingTimes !== null) {
        return this.openingTimes !== "" ? marked(this.openingTimes, {sanitize: true}) : "";
      }
      return "";
    },
    compiledMarkdownOffer: function () {
      if (this.offer !== null) {
        return this.offer !== "" ? marked(this.offer, {sanitize: true}) : "";
      }
      return "";
    },
    isDifferentDate: function () {
      return (this.previousRevision.time_period && this.previousRevision.time_period !== this.form.time_period)
          || (this.previousRevision.event_date && this.previousRevision.event_date !== this.form.event_date)
          || (this.previousRevision.select_month && this.previousRevision.select_month !== this.form.select_month)
          || (this.previousRevision.select_year_for_month && this.previousRevision.select_year_for_month !== this.form.select_year_for_month)
          || (this.previousRevision.select_quarter && this.previousRevision.select_quarter !== this.form.select_quarter)
          || (this.previousRevision.select_year_for_quarter && this.previousRevision.select_year_for_quarter !== this.form.select_year_for_quarter)
          || (this.previousRevision.select_year && this.previousRevision.select_year !== this.form.select_year)
          || (this.previousRevision.select_year_for_half_year && this.previousRevision.select_year_for_half_year !== this.form.select_year_for_half_year)
    },
  },

  methods: {

    newOpening: function () {

      // init
      let txtDescription = document.getElementById("description");
      let txtContent = $('#description').val();
      let count = (txtContent.match(/UPDATE #/g) || []).length + 1;
      let txtPattern = '';

      process.env.MIX_PLATFORM === "openings24" ? txtPattern = '**UPDATE #' + count + ' (' + moment().format('MM/DD/YYYY') + ')**\r\n\r\n[TEXT]\r\n\r\n---\r\n' : txtPattern = '**UPDATE #' + count + ' (' + moment().format('DD.MM.YYYY') + ')**\r\n\r\n[TEXT]\r\n\r\n---\r\n';

      $('#description').val(txtContent.slice(0, 0) + txtPattern + txtContent.slice(0));
      this.description = $('#description').val();

      txtDescription.focus();
      txtDescription.selectionStart = 0;
      txtDescription.selectionEnd = 0;

    },
    checkIsFile: function (image) {
      return image instanceof File;
    },

    formatDate(date) {
      process.env.MIX_PLATFORM === "openings24" ? this.dateFormat = "MM/DD/YYYY h:mm A" : this.dateFormat = "DD.MM.YYYY HH:mm";
      return moment(date, "YYYY-MM-DD HH:mm").format(this.dateFormat);
    },

    onTabSelected: function (tabIndex) {
      switch (tabIndex) {
        case 0:
          this.form.time_period = 1;
          this.form.select_month = "";
          this.form.select_year_for_month = "";
          this.form.select_quarter = "";
          this.form.select_year_for_quarter = "";
          this.form.select_year = "";
          this.form.select_half_year = "";
          this.form.select_year_for_half_year = "";
          break;
        case 1:
          this.form.time_period = 2;
          this.form.event_date = "";
          this.form.select_quarter = "";
          this.form.select_year_for_quarter = "";
          this.form.select_year = "";
          this.form.select_half_year = "";
          this.form.select_year_for_half_year = "";
          break;
        case 2:

          if (this.newForm === 'yes') {
            $("#select_year_for_quarter option[value='2020']").remove()
          }

          this.form.time_period = 3;
          this.form.event_date = "";
          this.form.select_month = "";
          this.form.select_year_for_month = "";
          this.form.select_year = "";
          this.form.select_half_year = "";
          this.form.select_year_for_half_year = "";
          break;
        case 3:

          if (this.newForm === 'yes') {
            $("#select_year_for_half_year option[value='2020']").remove()
          }

          this.form.time_period = 5;
          this.form.event_date = "";
          this.form.select_month = "";
          this.form.select_year_for_month = "";
          this.form.select_quarter = "";
          this.form.select_year_for_quarter = "";
          this.form.select_year = "";
          break;
        case 4:

          if (this.newForm === 'yes') {
            $("#select_year option[value='2020']").remove()
          }

          this.form.time_period = 4;
          this.form.event_date = "";
          this.form.select_month = "";
          this.form.select_year_for_month = "";
          this.form.select_quarter = "";
          this.form.select_year_for_quarter = "";
          this.form.select_half_year = "";
          this.form.select_year_for_half_year = "";
          break;
      }
    },
    descriptionUpdate: _.debounce(function (description) {
      this.description = description;
    }, 300),
    openingTimesUpdate: _.debounce(function (openingTimes) {
      this.openingTimes = openingTimes;
    }, 300),
    offerUpdate: _.debounce(function (offer) {
      this.offer = offer;
    }, 300),
    onFileChange: function (e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
    },
    handleUnknownContactPersonChange: function () {
      if (this.form.unknown_contact_person) {
        // Clear both fields when checkbox is checked
        this.form.contact_person = "";
        this.form.salutation = "";
        this.form.contact_position = "";
        this.form.contact_position_custom = "";
      }
    },
    handleContactPositionChange: function() {
      // Clear custom position when switching to a non-custom position
      if (this.form.contact_position !== 'custom') {
        this.form.contact_position_custom = "";
      }
    },
  }
};
</script>

